import React from "react";
import { useNavigate } from "react-router-dom";
import { chatHelpMessage } from "@/lib/helper";
import { headingVariants } from "@/lib/data";
import { motion } from "framer-motion";

import GoBackButton from "../buttons/GoBackButton";
import Stepper from "./stepper";
import WhatsappIcon from "@/assets/icons/whatsapp-icon-green.svg";
import NewCallButton from "@/assets/icons/calling.svg";
import { CircleUser } from "lucide-react";
import ProfileIcon from "@/assets/icons/f7_person-fill.svg";

const Header = ({
  total,
  progress,
  customBackSubmit,
  heading,
  subheading,
  showChat = true,
  showProfile = false,
}) => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col gap-8 w-full">
      <div className="flex flex-col justify-center items-center">
        <div className="flex flex-row w-full justify-between items-center">
          <GoBackButton customBackSubmit={customBackSubmit} />
          <div className="flex flex-row items-center gap-4">
            {showChat && (
              <button
                onClick={() => chatHelpMessage()}
                className="flex p-2 px-3 gap-2 justify-between items-center bg-slate-500/20 rounded-xl"
              >
                <img src={WhatsappIcon} alt="" className="size-7" />
                <span className="text-xs">Chat</span>
              </button>
            )}
            {showProfile && (
              <button onClick={() => navigate("/profile")}>
                <img src={ProfileIcon} alt="profile-icon" className="" />
              </button>
            )}
          </div>
        </div>
        {total && (
          <div className="flex flex-col w-1/3">
            <Stepper steps={total} currentStep={progress} />
          </div>
        )}
      </div>
      {(heading || subheading) && (
        <div className="flex flex-col gap-2 pr-2">
          {heading && (
            <motion.h1
              className="reveal-heading"
              initial="hidden"
              animate="visible"
              variants={headingVariants}
            >
              <span className="text-xl font-medium">{heading}</span>
            </motion.h1>
          )}
          {subheading && (
            <motion.h1
              className="reveal-heading"
              initial="hidden"
              animate="visible"
              variants={headingVariants}
            >
              <span className="text-base text-[#999999]">{subheading}</span>
            </motion.h1>
          )}
        </div>
      )}
    </div>
  );
};

export default Header;
